import React from 'react';

const Gifting: React.FC = () => {
  return (
    <div className="space-y-12">
      <div className="text-center">
        <h1 className="text-4xl font-display font-medium text-sage-800 mb-4">
          Gifting
        </h1>
        <div className="elegant-divider"></div>

        {/* Photo */}
        <div className="photo-frame max-w-xl mx-auto mt-10 mb-8" style={{width: '85%', height: '400px', overflow: 'hidden', display: 'block', backgroundColor: 'transparent'}}>
          {/* Desktop/Tablet Image */}
          <img
            src="/images/gifting/DSC06930_desktop_optimized.jpg"
            alt="Shivangi and Ishan"
            className="w-full h-full object-cover hidden sm:block"
            style={{ objectFit: 'cover', height: '100%', maxWidth: 'none' }}
            loading="lazy"
            decoding="async"
          />
          {/* Mobile Image */}
          <img
            src="/images/gifting/DSC06930_mobile_optimized.jpg"
            alt="Shivangi and Ishan"
            className="w-full h-full object-cover block sm:hidden"
            style={{ objectPosition: 'center' }}
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <p className="text-sage-grey-600 text-center">
        Your presence in our lives and at our celebration is truly the greatest gift to us. If you’d still like to contribute, here is how:
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="glass-card p-10 text-center">
          <div className="mb-6">
            <svg className="w-12 h-12 mx-auto text-sage-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76" />
            </svg>
          </div>
          <h3 className="font-display text-soft-black mb-4 tracking-wide">
            At the Wedding
          </h3>
          <p className="text-text-gray leading-relaxed">
            Please don't bring any boxed gifts.
          </p>
        </div>

        <div className="glass-card p-10 text-center">
          <div className="mb-6">
            <svg className="w-12 h-12 mx-auto text-sage-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="font-display text-soft-black mb-4 tracking-wide">
            Newlywed Fund
          </h3>
          <p className="text-text-gray leading-relaxed mb-6">
            Contribute to our newlywed fund online!
          </p>
          <a
            href="https://www.zola.com/registry/ishanandshivangi"
            target="_blank"
            rel="noopener noreferrer"
            className="minimal-button inline-block"
          >
            Registry
          </a>

        </div>
      </div>
    </div>
  );
};

export default Gifting;